import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import loadTranslations from 'js/localeSetup';
import DynamicComponent from './components/DynamicComponent';
import AnimationRunner from './components/AnimationRunner';
import SuccessPopup from './subcomponents/SuccessPopup';

import './assets/style.scss';

export default class Campaign extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      components: [],
      loaded: false
    };
    this.mapArray = this.mapArray.bind(this);
    this.handleEngageLoad = this.handleEngageLoad.bind(this);
  }

  componentDidMount() {
    this.setState({
      components: [...this.mapArray(this.props.components), <AnimationRunner />]
    });
  }

  handleEngageLoad() {
    this.setState({ loaded: true });
  }

  mapArray(jsonData) {
    const componentsArr = jsonData.map((element, i) => {
      if (i > 0) {
        return (
          <DynamicComponent
            path={`./${element.type}/index.jsx`}
            url={jsonData[0]}
            element={element}
            isBootroom={false}
            loaded={this.handleEngageLoad}
            campaignType={
              this.props.components[0].generalData
                ? this.props.components[0].generalData.campaignType
                : 'boot'
            }
            order={i}
            version={this.props.version}
          />
        );
      }
      return null;
    });
    return componentsArr;
  }

  render() {
    // check if engage is the first component to enable engage-first loading.
    let containsEngage = true;
    let num = 1;
    if (this.props.components[1].type !== 'engage') {
      containsEngage = false;
      num = 0;
    }

    return (
      <main id="campaign-system" dataid={this.props.campaignId}>
        {containsEngage && this.state.components[1]}
        {(this.state.loaded || containsEngage === false) &&
          this.state.components.map((component, i) => (
            <React.Fragment key={i}>{i > num && component}</React.Fragment>
          ))}
      </main>
    );
  }
}

const init = campaignId => {
  // Create axios GET request with proper headers
  const request = axios.create({
    headers: {
      'Content-Type': 'application/json'
    }
  });
  request.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
  request.defaults.xsrfCookieName = 'csrftoken';
  // Grab the data from the CMS
  request.get(`/u/campaign/get_json/?campaign_id=${campaignId}`).then(
    response => {
      if (response.data.finalData) {
        ReactDOM.render(
          <>
            <SuccessPopup
              ref={input => {
                window.popupContainer = input;
              }}
              commonTranslations={
                window.campaign_data.common_translations.blocks
              }
            />
            <Campaign
              components={response.data.finalData}
              version={response.data.version}
              campaignId={response.data.campaign_id}
            />
          </>,
          document.getElementById('campaign')
        );
      }
    },
    error => {
      console.log('No campaign-system data available ', error);
    }
  );
};

(async () => {
  await loadTranslations();

  if (window.campaign_data && window.campaign_data.campaign_id) {
    init(window.campaign_data.campaign_id);
  }
})();
